




































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class BargainResult extends Vue {
  @Prop() gainType!: string;
  @Prop() cutNumber!: number;
  @Prop() show!: boolean;
  @Getter("titleSection") titleSection!: object;

  timer: any = null;
  showStar: Boolean = false;

  @Watch("show")
  handleShowStart() {
    if (this.show)  {
      this.timer = window.setInterval(() => {
        this.showStar = !this.showStar;
      }, 1000);
    } else {
      window.clearInterval(this.timer);
    }
  }
  
  hideResult() { this.$emit("hide"); }
  
}
